import { formatDate } from "../../utils";
const FormatDate = (props) => {
    return (
      <div>
        {formatDate(props.value,'mm/dd/yyyy')}
      </div>
    );
}

export default FormatDate;